/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2022 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 10/25/22.
 */

function PrismInitializationController(
    this: JS5Object,
    $q: JS5Object,
    $scope: JS5Object,
    $timeout: JS5Function,
    loginService: JS5Object,
    DynamicStyleService: JS5Object,
    EchoService: JS5Object,
    MetadataService: JS5Object,
    RequestService: JS5Object,
    ServerInfoService: JS5Object,
) {
    let securedReqsStarted = false;

    const onStatusChange = () => {
        // Some initialization has to happen after login, so don't hide login screen
        this.loadingIndicator.show = (loginService.isAuthenticated() && this.isLoading);
        if (!securedReqsStarted && loginService.isAuthenticated()) {
            securedReqsStarted = true;
            MetadataService.initialize();
            $q.all([
                MetadataService.propertiesPromise,
                ServerInfoService.queryForServerInfo()
            ]).then(() => {
                this.isLoading = false;
                this.loadingIndicator.show = false;
            });
        }
    };

    this.$onInit = () => {
        this.isLoading = true;
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        loginService.useLocalStorage(true);
        DynamicStyleService.initialize();
        EchoService.initialize();
        RequestService.initialize();

        $scope.$on('$routeChangeStart', onStatusChange);
        onStatusChange();
    };
}

angular.module('prism-ui.components').component(
    'prismInitialization',
    {
        controller: PrismInitializationController,
        templateUrl: 'components/prism-initialization/prism-initialization-template.html'
    });
